// TODO: deprecate 'extended' related logics
const useConfiguration = (itemCount) => {
    const HAS_EXTENDED_ITEMS = itemCount ? itemCount > 3 : false;
    return {
        isExtended: HAS_EXTENDED_ITEMS,
    };
};
export default useConfiguration;
